import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    {
      label: 'Tour Packages',
      submenu: [
        { path: '/tours', label: 'All Tours' },
        { path: '/tours/domestic', label: 'Domestic Tours' },
        { path: '/tours/international', label: 'International Tours' },
        { path: '/tours/honeymoon', label: 'Honeymoon Packages' },
        { path: '/tours/group', label: 'Group Tours' },
        { path: '/tours/pilgrim', label: 'Pilgrim Tours' },
      ]
    },
    { path: '/contact', label: 'Contact Us' }
  ];

  return (
    <header className="sticky top-0 z-50 bg-white shadow-md">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_explore-skytrips/artifacts/n3t07i35_Sky_Trips_Logo-removebg-preview.png" 
              alt="Sky Trips Logo" 
              className="h-12 w-12 object-contain"
            />
            <div>
              <div className="text-3xl font-bold">
                <span className="text-sky-600">Sky</span>
                <span className="text-emerald-600">Trips</span>
              </div>
              <div className="text-sm font-medium text-emerald-600 -mt-1">
                Discover The World
              </div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navLinks.map((link, index) => (
              link.submenu ? (
                <div key={index} className="relative group">
                  <button className="nav-link font-medium text-gray-700 hover:text-sky-600 transition-colors">
                    {link.label}
                  </button>
                  <div className="absolute left-0 mt-2 w-56 bg-white rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                    <div className="py-2">
                      {link.submenu.map((sublink, subIndex) => (
                        <Link
                          key={subIndex}
                          to={sublink.path}
                          className="block px-4 py-2 text-gray-700 hover:bg-sky-50 hover:text-sky-600 transition-colors"
                        >
                          {sublink.label}
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              ) : (
                <Link
                  key={index}
                  to={link.path}
                  className={`nav-link font-medium transition-colors ${
                    location.pathname === link.path
                      ? 'text-sky-600'
                      : 'text-gray-700 hover:text-sky-600'
                  }`}
                >
                  {link.label}
                </Link>
              )
            ))}
          </nav>

          {/* Call Button */}
          <div className="hidden md:flex items-center space-x-4">
            <a href="tel:+919833280079">
              <Button className="bg-sky-600 hover:bg-sky-700 text-white">
                <Phone className="w-4 h-4 mr-2" />
                Call Now
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden pb-4">
            {navLinks.map((link, index) => (
              link.submenu ? (
                <div key={index} className="py-2">
                  <div className="font-medium text-gray-700 px-4 py-2">{link.label}</div>
                  {link.submenu.map((sublink, subIndex) => (
                    <Link
                      key={subIndex}
                      to={sublink.path}
                      className="block px-8 py-2 text-gray-600 hover:bg-sky-50 hover:text-sky-600"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {sublink.label}
                    </Link>
                  ))}
                </div>
              ) : (
                <Link
                  key={index}
                  to={link.path}
                  className="block px-4 py-2 text-gray-700 hover:bg-sky-50 hover:text-sky-600"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {link.label}
                </Link>
              )
            ))}
            <div className="px-4 py-2">
              <a href="tel:+919833280079">
                <Button className="w-full bg-sky-600 hover:bg-sky-700 text-white">
                  <Phone className="w-4 h-4 mr-2" />
                  Call Now
                </Button>
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};